import uniAdminApi from "./api";

const staffService = {
  getAdmins: async (page = 0, size = 10, config = {}) => {
    const res = await uniAdminApi.get("/university-admin/staff/admins", {
      params: { page, size },
      ...config,
    });
    return res.data;
  },

  getAdmin: async (userId) => {
    const res = await uniAdminApi.get(`/university-admin/staff/admins/${userId}`);
    return res.data;
  },

  createAdmin: async (data) => {
    const res = await uniAdminApi.post("/university-admin/staff/admins", data);
    return res.data;
  },

  promoteAdmin: async (email) => {
    const res = await uniAdminApi.post("/university-admin/staff/admins/promote", { email });
    return res.data;
  },

  changeAdminType: async (userId, adminType) => {
    const res = await uniAdminApi.put(`/university-admin/staff/admins/${userId}/type`, { adminType });
    return res.data;
  },

  setAllClubsAccess: async (userId, enabled) => {
    const res = await uniAdminApi.put(`/university-admin/staff/admins/${userId}/all-clubs-access`, { enabled });
    return res.data;
  },
};

export default staffService;
